import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import EventCourses from './EventCourses';

const mapStateToProps = (state, ownProps) => ({ ...ownProps });

export default withRouter(connect(mapStateToProps)(EventCourses));
